import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

import { behaviorGoals } from '../../../../../../manage-settings/manage-settings.interface';

@Component({
  selector: 'app-define-behavior-wizard-goals-step',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzButtonModule,
    NzInputModule,
  ],
  templateUrl: './define-behavior-wizard-goals-step.component.html',
})
export class DefineBehaviorWizardGoalsStepComponent {
  @Input() form!: FormGroup;
  @Input() isRequired = false;
  @Input() behaviorGoal: behaviorGoals | null = null;
  @Input() getBehaviorGoalLabel!: (categoryId: number) => string;
  @Input() onControlInputChange!: (
    event: Event,
    control: AbstractControl | null
  ) => void;
  @Output() openExampleOfGoals = new EventEmitter<void>();
}
